<template>
    <el-dialog
        :visible.sync="txcs.openShow"
        :show-close="false"
        :close-on-click-modal="false"
        @opened="handleOpen"
    >
        <div style="box-sizing: border-box;padding: 20px;height: 100%;">
            <div style="height: calc(100% - 50px);background-color: #f7f7f7;padding: 20px;">
                <div style="display: flex;margin-bottom: 20px;align-items:center;">
                    <div style="margin: 0 10px;font-weight: 700;font-size: 18px;height: 40px;line-height: 40px;color: #343434;">
                        <span>{{ tzxxName }}</span>
                    </div>
                    <div>
                        <el-date-picker
                            size="mini"
                            style="margin-left: 20px;width: 35rem;margin-right: 20px;"
                            v-model="sstj.date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            @change="handleOpen"
                        >
                        </el-date-picker>
                        <el-button type="primary" size="small" style="background-color: #a8a8a8;border: solid 0rem #f4f4f4;" @click="resetGetData">重置</el-button>
                        <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="handleOpen">搜索</el-button>
                    </div>
                    <el-image class="tabDelImg" :src="require('../../assets/tab-del.png')" @click="handleClose"></el-image>
                </div>
                <div v-if="tzxxData.length > 0">
                    <div style="display: flex;align-items: center;">
                        <img src="../../assets/video/dy.png" @click="tztpPoz('dy')" style="width: 20px;height: 20px;margin-right: 10px;cursor: pointer;">
                        <img src="../../assets/video/ht.png" @click="tztpPoz('ht')" style="width: 20px;height: 20px;margin-right: 10px;cursor: pointer;">
                        <img src="../../assets/video/bf.png" v-if="!bfzt" @click="lbtZt()" style="width: 20px;height: 20px;margin-right: 10px;cursor: pointer;">
                        <img src="../../assets/video/zt.png" v-else @click="lbtZt()" style="width: 20px;height: 20px;margin-right: 10px;cursor: pointer;">
                        <img src="../../assets/video/qj.png" @click="tztpPoz('qj')" style="width: 20px;height: 20px;margin-right: 10px;cursor: pointer;">
                        <img src="../../assets/video/zh.png" @click="tztpPoz('zh')" style="width: 20px;height: 20px;margin-right: 30px;cursor: pointer;">
                        <el-slider v-model="percentage" :step="1" :min="1" :max="tzxxData.length" style="width: 90%;"></el-slider>
                    </div>
                    <div style="display: flex;margin: 15px 0;height: 100%;">
                        <div style="width: 78%;margin-right: 2%;">
                            <el-carousel trigger="click" :autoplay="bfzt" height="65vh" class="syLbt" @change="lbtChange" ref="carousel">
                                <el-carousel-item v-for="item in tzxxData" :key="item">
                                    <img :src="fileHost + item.path" style="width: 100%;">
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div style="width: 20%;">
                            <div style="border: 1px solid #787878;height: 65vh;padding: 2px;overflow-y: auto;">
                                <div v-for="item,index in tzxxData" :key="index" style="height: 40px;font-size: 16px;text-align: center;line-height: 40px;cursor: pointer;" :class="xzIndex == index ? 'xzClass' : ''" @click="handleXz(index)">
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-row v-else>
                    <div style="width: 100%;text-align: center;height: 100px;font-size: 20px;margin-top: 50px;">
                        暂无图片
                    </div>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
  
<script>
import {fileHost} from "@/utils/config";

export default {
    props:{
        txcs:{
            type:Object
        },
    },
    data() {
        return {
            fileHost:fileHost,
            sstj: {
                date:[],
                czOrbh: '',
                size: 20,
                current: 1,
                total: 0,
            },
            tzData: [],
            tzxxData: {},
            tzxxName:'',
            
            
            tzDataX: {
                spDialogVisible: false,
            },
            percentage: 1,
            xzIndex: 0,
            bfzt:false,
        }
    },
    mounted() {
        this.initDataItem();
    },
    methods: {
        initDataItem(){
            var today = new Date();
            var jr = ''
            var zr = ''
            if(today.getHours() < 8){
                jr = this.getDay(-1).substring(0,this.getDay(0).length-5)
                zr = this.getDay(-2).substring(0,this.getDay(0).length-5)
            }else{
                jr = this.getDay(0).substring(0,this.getDay(0).length-5)
                zr = this.getDay(-1).substring(0,this.getDay(0).length-5)
            }
            this.sstj.date = []
            this.sstj.date.push(jr+"08:00")
            this.sstj.date.push(this.getDay(0))
        },
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码

            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            var thours = today.getHours();
            thours = this.doHandleMonth(thours);
            var tMinute =  today.getMinutes();
            tMinute = this.doHandleMonth(tMinute);
            return tYear + "-" + tMonth + "-" + tDate +" "+thours+":"+tMinute;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },
        
        resetGetData(){
            this.sstj = {
                czOrbh:'',
                size: 20,
                current: 1,
                total: 0,
            }
            this.handleOpen();
        },

        handleOpen(){
            this.tzxxName = this.txcs.cz.stnm;
            let params = {
                stcd:this.txcs.cz.stcd,
                dtGT:this.sstj.date[0] + ':00',
                dtLE:this.sstj.date[1] + ':00',
            }
            this.request.get("/rm-bimage/queryImageListByStcd", {params: params}).then((res) => {
                if (res.ok) {
                    this.tzxxData = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        handleClose() {
            this.txcs.openShow = false;
            this.percentage = 1;
            this.xzIndex = 0;
            this.bfzt = false;
        },
        tztpPoz(z){
            if (z == 'dy') {
                this.percentage = 1;
                this.xzIndex = this.percentage - 1;
                this.$refs.carousel.setActiveItem(this.xzIndex)
            } else if (z == 'ht') {
                if (this.percentage == 1) {
                    this.percentage = this.tzxxData.length;
                    this.xzIndex = this.percentage - 1;
                    this.$refs.carousel.prev();
                } else {
                    this.percentage = --this.percentage;
                    this.xzIndex = this.percentage - 1;
                    this.$refs.carousel.prev();
                }
            } else if (z == 'qj') {
                if (this.percentage == this.tzxxData.length) {
                    this.percentage = 1;
                    this.xzIndex = this.percentage - 1;
                    this.$refs.carousel.next();
                } else {
                    this.percentage = ++this.percentage;
                    this.xzIndex = this.percentage - 1;
                    this.$refs.carousel.next();
                }
            } else if (z == 'zh') {
                this.percentage = this.tzxxData.length;
                this.xzIndex = this.percentage - 1;
                this.$refs.carousel.setActiveItem(this.xzIndex)
            }
        },
        handleXz(index){
            this.xzIndex = index;
            this.percentage = this.xzIndex - 1;
        },
        lbtZt(){
            this.bfzt = !this.bfzt;
        },
        lbtChange(index){
            this.percentage = index + 1;
            this.xzIndex = index;
        },
    },
}
</script>
<style scoped>
::v-deep .el-dialog{
    margin-top: 110px !important;
    margin-bottom:0;
    width: 100% !important; 
    height: calc(100% - 110px);
}
/*去除头部*/
::v-deep .el-dialog__header{
    display: none;
}
/*去除尾部*/
::v-deep .el-dialog__footer{
    display: none;
}
::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
}


.tabDelImg {
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    position: absolute;
    right: 40px;
}

/* 隐藏百分比单位 */
::v-deep .el-progress__text {
    display: none !important;
}
.xzClass{
    background-color: #52abff;
    color: #fff;
}
/* 轮播图样式 */
.syLbt /deep/ .el-carousel__indicator--horizontal .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #375ff6;
    border: 1px solid #375ff6;
    border-radius: 50%;
    opacity: 0.3;
}
.syLbt /deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button{
    width: 8px;
    height: 8px;
    background: #375ff6;
    border-radius: 50%;
    opacity: 1;
}
.syLbt /deep/ .el-carousel__arrow {
    height: 50px;
    width: 50px;
    cursor: pointer;
    background-color: rgb(0 0 0 / 0%);
    color: #DDDDDD;
    font-size: 50px;
}
/deep/ ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
/deep/ ::-webkit-scrollbar-track {
    --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 6px;
}
/deep/ ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgb(220, 220, 220);
    --webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.5);
}
/deep/ ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(220,220,220,0.4);
}
</style>